import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Message {
  private readonly http = inject(HttpClient);

  packageList(filters: any): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.package.packageList}`, {
      params: filters
    });
  }

  validateGSM(message: any): Observable<any> {
    return this.http.post<any>(
      `${environment.apiPrefix}${environment.message.validateGSM}`,
      message
    );
  }

  sendMessage(data: any): Observable<any> {
    return this.http.post<any>(`${environment.apiPrefix}${environment.message.sendMessage}`, data);
  }
}
